import neverLandUtils from "../utils/NeverLandUtils";

export const STORE_CODE = 'eb_sc'
export const DEVICE_CODE = 'eb_dc'
export const SET_MONEY_BUTTON_LIST = 'eb_mb'
export const DEVICE_SETTING = 'd_set'
export const PERMISSION_LIST = 'p_list'
export const DEVICE_SETTING_DEFAULT_LIST = {
  dark_mode: true,
  folder_toggle_mode: false,
  show_basket: true,
  basket_fixed_print: false,
  proto_sort_by_number: false, // false = 경기시간순, true = 경기번호순
};


class MyAccountInfo {
  //로컬스토리지 저장되어있는 정보 가져오기

  storeCode() { // 로그인 했을 때 받은 지점 코드
    return neverLandUtils.commons.load(STORE_CODE) || -1;
  }

  deviceCode() {  // 로그인 했을 때 받은 기기 코드
    return neverLandUtils.commons.load(DEVICE_CODE) || -1;
  }

  getDeviceSetting() {  // 기기 설정 정보 가져오기
    return neverLandUtils.commons.load(DEVICE_SETTING) || -1;
  }

  isProtoSortByNumber() {  // 경기번호순 정렬 여부 (false = 경기시간순)
    const setting = this.getDeviceSetting();
    if (!setting || setting.proto_sort_by_number === undefined) return false;
    return setting.proto_sort_by_number;
  }

  isDarkMode() {  // 화면 다크모드 여부
    const isDarkMode = this.getDeviceSetting() ? this.getDeviceSetting().dark_mode : true;

    // 다크 모드 여부에 따라 css 클래스 추가
    if (isDarkMode !== null && !isDarkMode) {
      document.body.classList.add('light-mode');
    } else {
      document.body.classList.remove('light-mode');
    }

    if (isDarkMode === null) return true; // 값이 없으면 다크모드
    return isDarkMode;
  }
}

const {REACT_APP_SERVER_IMAGE_FOLDER} = process.env;

const image_resource_urls = {
  // 경기장
  'soccer_ground': REACT_APP_SERVER_IMAGE_FOLDER + "/soccer_play_ground.img",
};

export function getImage(shape) {
  let currentUrl = window.location.href;
  let _url = image_resource_urls[shape];

  if (currentUrl.includes('.com')) {
    const newUrl = new URL(_url);
    newUrl.hostname = currentUrl.replace('http://', '').replace('https://', '').split("/")[0]; // 도메인 부분만 대체

    _url = newUrl.href;
  }

  if (_url !== undefined) {
    return _url;
  }
}

export const today = new Date();
export const month = today.getMonth();
export const day = today.getDate();
export const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);

export const lastWeek = new Date(today);
lastWeek.setDate(today.getDate() - 7);

export const lastMonth = new Date(today);
lastMonth.setMonth(today.getMonth() - 1);

export const accountInfo = new MyAccountInfo();



